// React
import React from 'react';
import { Button, Col, Input, Row } from 'reactstrap';

export const RemoteSearchBySituation = ({
  handleSearch,
  handleExportExcel,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch(e.target.search.value);
      }}
    >
      <div style={{ marginTop: 15, marginBottom: 15 }}>
        <Row
          xs={12}
          md={12}
          lg={12}
          className="d-flex align-items-center g-3 ms-2"
        >
          <Col xs={4} md={4} lg={4}>
            <div className="search-box">
              <input
                id="search"
                type="text"
                className="form-control search"
                placeholder="Pesquisar"
                onChange={(e) => {
                  const { value } = e.target;
                  if (value.length === 0) {
                    handleSearch('');
                  }
                }}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </Col>

          <Col xs={1} md={1} lg={1}>
            <button
              type="submit"
              className="btn btn-primary btn-sm btn-label waves-effect waves-light"
            >
              <i className="ri-search-2-line label-icon align-middle fs-14 me-2"></i>{' '}
              Pesquisar
            </button>
          </Col>
          <Input type="submit" hidden />

          <Col className="text-end me-2">
            <Button
              outline
              type="button"
              color="primary"
              onClick={() => {
                handleExportExcel();
              }}
            >
              <i className="ri-download-2-line align-bottom me-1"></i>
              Exportar
            </Button>{' '}
          </Col>
        </Row>
      </div>
    </form>
  );
};
